import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/data/content";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav" : "bg-white border-b border-transparent"
      }`}
    >
      <div className="mv-container flex items-center justify-between h-20">
        <Link to="/" data-testid="navbar-logo-link" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="MIREVSA"
            className="h-12 w-12 object-contain"
          />
          <div className="leading-tight">
            <div className="font-heading font-black text-lg tracking-tight text-[#1C1C1C]">
              MIREVSA
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#0B3D91] font-bold">
              La Quête des Âmes
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive
                    ? "text-[#0B3D91]"
                    : "text-[#1C1C1C] hover:text-[#0B3D91]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/join" data-testid="nav-join-btn" className="btn-outline !py-2.5 !px-5 text-sm">
            Rejoindre
          </Link>
          <Link to="/donation" data-testid="nav-donate-btn" className="btn-primary !py-2.5 !px-5 text-sm">
            Faire un don
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-[#1C1C1C]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="lg:hidden bg-white border-t border-gray-100 animate-fade-in"
        >
          <div className="mv-container py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${
                    isActive ? "text-[#0B3D91]" : "text-[#1C1C1C]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="flex gap-3 pt-3 border-t border-gray-100">
              <Link to="/join" className="btn-outline flex-1 !py-2.5 text-sm">
                Rejoindre
              </Link>
              <Link to="/donation" className="btn-primary flex-1 !py-2.5 text-sm">
                Faire un don
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
